// src/components/Calendar/CalendarAdmin.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import '../css/CalendarAdmin.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CalendarAdmin = () => {
    const [title, setTitle] = useState('');
    const [selectedDate, setSelectedDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [description, setDescription] = useState('');
    const [calendarDays, setCalendarDays] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(dayjs());
    const [showModal, setShowModal] = useState(false);

    // Generate calendar days only when currentMonth changes
    useEffect(() => {
        const generateCalendarDays = () => {
            const startOfMonth = currentMonth.startOf('month').day();
            const daysInMonth = currentMonth.daysInMonth();
            const days = Array(startOfMonth).fill(null); // fill empty days for offset

            for (let i = 1; i <= daysInMonth; i++) {
                days.push(dayjs(currentMonth).date(i).format('YYYY-MM-DD'));
            }

            setCalendarDays(days);
        };

        generateCalendarDays();
    }, [currentMonth]);

    const handlePrevMonth = () => setCurrentMonth(currentMonth.subtract(1, 'month'));
    const handleNextMonth = () => setCurrentMonth(currentMonth.add(1, 'month'));

    const handleDateSelect = (date) => {
        setSelectedDate(date);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setTitle('');
        setDescription('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_BASE_URL}/calendar`, { title, date: selectedDate, description }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            alert('Calendar entry added successfully');
            setTitle('');
            setDescription('');
            setShowModal(false);
        } catch (error) {
            console.error('Error adding calendar entry:', error);
            alert(error.response?.data?.message || 'Failed to add calendar entry');
        }
    };

    return (
        <div className="calendar-admin-container">
            <h2>Admin Calendar Management</h2>
            
            <div className="calendar-navigation">
                <button onClick={handlePrevMonth}>Previous</button>
                <span>{currentMonth.format('MMMM YYYY')}</span>
                <button onClick={handleNextMonth}>Next</button>
            </div>
            
            <div className="calendar-grid">
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                    <div key={day} className="calendar-day-header">{day}</div>
                ))}
                {calendarDays.map((date, index) => (
                    <div
                        key={index}
                        className={`calendar-day ${date === selectedDate ? 'selected' : ''}`}
                        onClick={() => date && handleDateSelect(date)}
                    >
                        {date ? dayjs(date).date() : ''}
                    </div>
                ))}
            </div>

            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close-button" onClick={handleCloseModal}>&times;</span>
                        <h3>Add Event for {dayjs(selectedDate).format('MMMM D, YYYY')}</h3>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder="Title"
                                value={title}
                                onChange={e => setTitle(e.target.value)}
                                required
                            />
                            <textarea
                                placeholder="Description"
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                            />
                            <button type="submit">Add Entry</button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CalendarAdmin;
